/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Vladimir Prudilin <vladimir.prudilin@opensoftdev.ru>
 */
define(['jquery'], function($) {
    const EVENT_PRODUCT_SELECT = 'product.select';
    const PRODUCT_GROUP_TITLE = 'product-group-title';
    const PRODUCT_NAME = 'product-name';

    const G4_ITEM_NAME = 'item_name';
    const G4_ITEM_CATEGORY = 'item_category';

    return {
        SHOPPING_CART_SHIPPING_LOADED: 'onp:cart:shipping:loaded',
        ROYAL_SLIDER_CHANGE: 'onp:royal-slider:change',

        /**
         * @param {jQuery} $elements
         */
        pushAdobeProductsFromElements: function($elements) {
            let adobeProducts = [];

            $elements.each(function() {
                let productGroupTitle = $(this).data(PRODUCT_GROUP_TITLE);
                let productName = $(this).data(PRODUCT_NAME);
                if (productGroupTitle && productName) {
                    let product = {};
                    product[G4_ITEM_CATEGORY] = productGroupTitle;
                    product[G4_ITEM_NAME] = productName;
                    adobeProducts.push(product);
                }
            });

            this.pushProductsToAdobe(adobeProducts);
        },

        /**
         * @param {array} adobeProducts
         */
        pushProductsToAdobe: function(adobeProducts) {
            if (!window.dataLayer) {
                return;
            }

            window.dataLayer.push({
                event: EVENT_PRODUCT_SELECT,
                items: adobeProducts
            });
        },

        /**
         * @param {String} name
         * @param {Object} data
         */
        pushData: function(name, data) {
            if (!window.dataLayer) {
                return;
            }

            window.dataLayer.push({
                event: name,
                data: data
            });
        }
    };
});
